import React from "react";
import BookingFlowScreeningIndicator from "./booking-flow-screening-indicator";
import BookingFlowStepNav from "./booking-flow-step-nav";
import { BookingFlowStepId } from "./types";
import layoutStyles from "./booking-flow-layout.module.css";

type BookingFlowEmbeddedShellProps = {
    children: React.ReactNode;
    currentStep: BookingFlowStepId;
    showScreeningIndicator?: boolean;
    skipConsultationStep?: boolean;
    /** Adds top inset when the global hold timer sits above this card. */
    belowHoldTimer?: boolean;
    /** Less padding above step body (e.g. confirmation checkmark). */
    compactTopPadding?: boolean;
};

/** Card chrome for steps inside an existing page (e.g. screening payment). */
const BookingFlowEmbeddedShell: React.FunctionComponent<BookingFlowEmbeddedShellProps> = ({
    children,
    currentStep,
    showScreeningIndicator = true,
    skipConsultationStep,
    belowHoldTimer = false,
    compactTopPadding = false,
}) => {
    return (
        <div
            className={`${layoutStyles.cardShell} ${
                belowHoldTimer ? layoutStyles.cardShellBelowHoldTimer : ""
            }`}
        >
            {showScreeningIndicator && <BookingFlowScreeningIndicator />}
            <BookingFlowStepNav
                currentStep={currentStep}
                skipConsultationStep={skipConsultationStep}
            />
            <div
                className={`${layoutStyles.body} ${
                    layoutStyles.bodyLegacyContent
                } ${compactTopPadding ? layoutStyles.bodyCompactTop : ""}`}
            >
                {children}
            </div>
        </div>
    );
};

export default BookingFlowEmbeddedShell;
